import { useQuery } from '@tanstack/react-query';

import { Folder, RawFolder } from '../types';
import { FolderGateway } from '../gateways';
import { handleResponse } from '@/core/utils/response';
import { folderKeyFactory } from '@/core/query-keys';

interface QueryProps {
  parentId?: string;
}

async function fetchFolderNames({ parentId }: QueryProps) {
  return handleResponse(FolderGateway.fetchNameList({ parentId }));
}

export function useFetchFolderNames({ parentId }: QueryProps) {
  return useQuery<RawFolder[], Error, Folder[]>(folderKeyFactory.nameList(parentId), () =>
    fetchFolderNames({ parentId })
  );
}
